module.exports = __webpack_public_path__ + "static/media/icon-event__conflicto-en-los-balcanes.0701f2f6.svg";